/**
 * wap(移动端)适配公共方法
 * 断点与各组件 less 中的 @media screen and (max-width: 768px) 保持一致，
 * 修改时请两边同步。
 */
export const WAP_MAX_WIDTH = 768;

/**
 * 是否为wap端
 * 只按可视宽度判断，保证与 css 媒体查询的表现完全一致
 * (PC浏览器把窗口缩小到768px以内同样按wap展示)
 */
export function isWapDevice() {
  const width = document.documentElement.clientWidth || window.innerWidth || 0;
  return width <= WAP_MAX_WIDTH;
}

/**
 * 组件内混入后可直接使用 this.isWap (响应式，窗口尺寸变化自动更新)
 * 用法：
 *   import { wapMixin } from '../../utils/device';
 *   export default { mixins: [wapMixin] }
 */
export const wapMixin = {
  data() {
    return {
      isWap: isWapDevice(),
    };
  },
  mounted() {
    window.addEventListener('resize', this.$_wapResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_wapResize);
  },
  methods: {
    $_wapResize() {
      const wap = isWapDevice();
      if (wap !== this.isWap) {
        this.isWap = wap;
      }
    },
  },
};

export default wapMixin;
